import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  organisation: null,
  navbarSearch: "",
  sidebarModalType: "",
  isSidebarModalOpen: false,
};

export const sidebar = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebarSliceData: (state, { payload }) => {
      if (payload.type && payload.type in state) {
        state[payload.type] = payload.data;
      }
    },
    setOrganisation: (state, { payload }) => {
      state.organisation = payload;
    },
    setNavbarSearch: (state, { payload }) => {
      state.navbarSearch = payload;
    },
  },
});

export const { setSidebarSliceData, setOrganisation, setNavbarSearch } =
  sidebar.actions;

export default sidebar.reducer;
